module.exports = __webpack_public_path__ + "static/img/level_bg_on.28650e77.png";